import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

const Container = styled.div<{ tileWidth: string; maxRows?: number }>`
    display: grid;
    grid-template-columns: ${({ tileWidth }) => `repeat(auto-fill, minmax(${tileWidth}, 1fr))`};
    grid-row: 1; /* Ensure each row takes up equal height */
    grid-gap: 24px;
    justify-content: space-between;
    overflow: hidden;

    ${({ maxRows }) =>
        !!maxRows &&
        `
    grid-template-rows: repeat(${maxRows}, 1fr);
    grid-auto-rows: 0; /* set height to 0 for autogenerated grid rows
  `}
`;

export const TileSkeleton = styled(Skeleton)<{ height: string }>`
    border-radius: 11px;
    height: ${({ height }) => height};
    width: 100%;
    margin-top: 0;
    transform: unset;
`;

interface Props {
    amount?: number;
    tileWidth: string;
    tileHeight: string;
    maxRows?: number;
    className?: string;
}

export const LibrarySkeleton = ({ amount = 4, tileWidth, tileHeight, maxRows, className }: Props) => {
    return (
        <Container tileWidth={tileWidth} maxRows={maxRows} className={className}>
            {new Array(amount).fill('').map((_, i) => (
                <TileSkeleton key={i} height={tileHeight} />
            ))}
        </Container>
    );
};
